<template>
  <div class="sdk-content">
    <div class="title-wrapper">
      <span class="sdk_title">SDK业务</span>
    </div>

    <!-- 广告SDK卡片 -->
    <div class="sdk-wrapper">
      <div class="sdk-card">
        <div class="sdk-version">
          <!-- <span class="version-num">3.5.10</span> -->
          <span class="version-text">广告SDK</span>
        </div>
        <div class="sdk-info">
          <div class="info-item">
            <div class="label">SDK名称</div>
            <div class="value">九吨A广告SDK</div>
          </div>
          <div class="info-item">
            <div class="label">SDK所属企业名称</div>
            <div class="value">重庆市九吨科技<br>有限公司</div>
          </div>
          <div class="info-item">
            <div class="label">SDK说明</div>
            <div class="value">用于广告投放、广告监测、<br>广告归因、广告效果优化</div>
          </div>
        </div>
      </div>
      <div class="sdk-links">
        <a href="https://nineton.cn/advertising2.0.html" target="_blank">Android接入文档 →</a>
        <a href="https://nineton.cn/advertising_ios.html" target="_blank">iOS接入文档 →</a>
        <a href="https://nineton.cn/ad_privacy2.0.html" target="_blank">隐私政策 →</a>
        <a href="https://nineton.cn/sdk_guide2.0.html" target="_blank">合规使用文档 →</a>
      </div>
    </div>

    <!-- 统计SDK卡片 -->
    <div class="sdk-wrapper">
      <div class="sdk-card">
        <div class="sdk-version">
          <!-- <span class="version-num">2.0.5</span> -->
          <span class="version-text">统计SDK</span>
        </div>
        <div class="sdk-info">
          <div class="info-item">
            <div class="label">SDK名称</div>
            <div class="value">【九吨Android统计SDK】&【九吨iOS统计SDK】</div>
          </div>
          <div class="info-item">
            <div class="label">SDK所属企业名称</div>
            <div class="value">重庆市九吨科技有限公司</div>
          </div>
          <div class="info-item">
            <div class="label">SDK说明</div>
            <div class="value">进行APP数据统计分析</div>
          </div>
        </div>
      </div>
      <div class="sdk-links">
        <a href="https://nineton.cn/sdk_statistical_acc2.0.html" target="_blank">Android接入文档 →</a>
        <a href="https://nineton.cn/sdk_statistical_acc_ios.html" target="_blank">iOS接入文档 →</a>
        <a href="https://nineton.cn/analysis_privacy2.0.html" target="_blank">隐私政策 →</a>
        <a href="https://nineton.cn/sdk_statistic2.0.html" target="_blank">合规使用文档 →</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageSdk'
}
</script>

<style scoped lang="less">
.sdk-content {
  margin-top: .9333rem;

  .title-wrapper {
    margin-bottom: 1.2rem;
  }

  .sdk_title {
    font-weight: 600;
    font-size: .4rem;
    position: relative;

    &::after {
      content: '';
      width: .4533rem;
      height: .0933rem;
      background: #F7931E;
      border-radius: .0533rem;
      position: absolute;
      left: 0;
      bottom: -.2667rem;
    }
  }

  .sdk-wrapper {
    margin-top: .9333rem;
    margin-bottom: .9333rem;

    .sdk-card {
      background: #ffffff;
      border: 1px solid #eee;
      border-radius: .2133rem;
      padding: .8rem .5333rem;
      position: relative;

      .sdk-version {
        position: absolute;
        top: -.44rem;
        left: 0;
        width: 4.32rem;
        height: 1.18rem;
        background: #242424;
        border-radius: .1563rem .1563rem .1563rem .0104rem;
        color: #fff;
        display: flex;
        align-items: center;
        padding-left: .8rem;
        gap: .2667rem;

        .version-num {
          font-size: .48rem;
          font-family: "PingFang SC";
          font-weight: 600;
          font-style: italic;
        }

        .version-text {
          font-size: .3733rem;
          font-family: "PingFang SC";
          font-weight: 400;
          opacity: 0.8;
        }
      }

      .sdk-info {
        margin-top: .5333rem;

        .info-item {
          margin-bottom: .4rem;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;

          .label {
            color: #666666;
            font-size: .3733rem;
            font-family: "PingFang SC";
            font-weight: 400;
            margin-bottom: 0;
            width: 35%;
          }

          .value {
            color: #333333;
            font-size: .3733rem;
            font-family: "PingFang SC";
            font-weight: 600;
            line-height: 1.5;
            width: 60%;
            text-align: right;
            word-wrap: break-word;
            word-break: break-all;
          }
        }
      }
    }

    .sdk-links {
      display: flex;
      justify-content: space-around;
      margin-top: .4rem;
      gap: .8rem;

      a {
        color: #f7931e;
        text-decoration: none;
        font-size: .3467rem;
        font-family: "PingFang SC";
        font-weight: 400;
        opacity: 1;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>